import { createQueryHook } from "../factory";

const procedureCodeKeys = {
  all: ["procedureCodes"] as const,
  lists: () => [...procedureCodeKeys.all, "list"] as const,
  list: <T>(filters: T) => [...procedureCodeKeys.lists(), filters] as const,
};

export const procedureCodes = {
  getUniqueProcedureCodes: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.procedureCodes.getUniqueProcedureCodes,
    queryKeyFn: procedureCodeKeys.list,
  }),
};
